import { gql } from "@apollo/client";

export const CREATE_PLAN = gql`
    mutation createPlan($data: CreatePlanInput!) {
        createPlan(data: $data) {
            id
            name
            value
            requests
            description
            is_actived
        }
    }
`;

export const UPDATE_PLAN = gql`
    mutation updatePlan($data: UpdatePlanInput!) {
        updatePlan(data: $data) {
            id
            name
            value
            requests
            description
            is_actived
        }
    }
`;

export default CREATE_PLAN;
